import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Table, Button, FormControl } from 'react-bootstrap';
import cx from 'classnames';

import Link from '../../Link';
import CustomPagination from '../../CustomPagination';
import Loader from '../../../components/Common/Loader';

import history from '../../../history';
import updateSubCategoryStatus from '../../../actions/siteadmin/SubCategory/updateSubCategoryStatus';
import deleteSubCategory from '../../../actions/siteadmin/SubCategory/deleteSubCategory';
import debounce from '../../../helpers/debounce';
import messages from '../../../locale/messages';
import getCurrentPage from '../../../helpers/getCurrentPage';
import { demoRestriction } from '../../../actions/demoRestriction';

import { CommonAdminEditIcon, CommonAdminTrashIcon } from '../../Common/Assets/SVGIcon/CommonSvgIcon';

import bt from '../../../components/commonStyle.css';
import s from './SubCategoryList.css';

class SubCategoryList extends React.Component {
  static propTypes = {
    subCategoryDetails: PropTypes.object,
  };
  constructor(props) {
    super(props)
    this.state = {
      currentPage: 1,
      searchList: ''
    }
  }

  handleClick = () => {
    history.push('/add')
  }

  handleKeywordSearch = debounce((searchList) => {
    const { subCategoryDetails: { refetch } } = this.props
    let variables = {
      currentPage: 1,
      searchList: searchList
    }
    this.setState({ searchList, currentPage: 1 });
    refetch(variables);;
  });

  handleDelete = async (id, currentPage) => {
    const { deleteSubCategory, subCategoryDetails: { refetch, getAllSubCategory }, demoRestriction } = this.props;
    const isRestrict = await demoRestriction({ restrictType: 'subCategory', restrictValue: id });
    if (isRestrict) return;
    currentPage = await getCurrentPage({ results: getAllSubCategory?.results, page: currentPage });
    let variables = { currentPage }
    const response = await deleteSubCategory(id, currentPage);
    if (response?.status == 200) {
      this.setState({ currentPage });
      refetch(variables)
    }
  }

  paginationData = (currentPage) => {
    const { subCategoryDetails: { refetch } } = this.props;
    let variables = { currentPage };
    this.setState({ currentPage });
    refetch(variables);
  }

  handleStatus = async (id, currentPage, fieldName, e) => {
    const { updateSubCategoryStatus, subCategoryDetails: { refetch }, demoRestriction } = this.props;
    let value = e.target.value;
    const isRestrict = await demoRestriction({ restrictType: 'subCategory', restrictValue: id });
    if (isRestrict) return;
    await updateSubCategoryStatus(id, currentPage, fieldName, value);
    let variables = { currentPage };
    this.setState({ currentPage });
    refetch(variables);
  }

  render() {
    const { subCategoryDetails, subCategoryDetails: { getAllSubCategory, loading } } = this.props;
    const { formatMessage } = this.props.intl;
    const { currentPage } = this.state;
    return (
      <div className={'whiteDropdown'}>
        <div className={s.exportDisplay}>
          <div className={s.searchGroupContainer}>
            <div className={cx(s.searchInput, 'searchInputRTL')}>
              <FormControl type='text' placeholder={formatMessage(messages.searchOnly)} onChange={(event) => this.handleKeywordSearch(event.target && event.target.value)} className={bt.formControlInput} />
            </div>
          </div>
          <div className={cx(s.exportTextSection)}>
            <Link to={"/siteadmin/sub-category/add"} className={cx(bt.btnPrimary, bt.displayInlineBlock)} >{formatMessage(messages.addSubCategory)}</Link>
          </div>
        </div>
        {
          loading && <div>
            <Loader type="circle" />
          </div>
        }
        {!loading &&
          <div className='tableOuterContainer'>
            <Table className="tableContainer">
              <thead>
                <tr>
                  <th scope="col"><FormattedMessage {...messages.id} /></th>
                  <th scope="col"><FormattedMessage {...messages.subCategoryName} /></th>
                  <th scope="col"><FormattedMessage {...messages.categoryName} /></th>
                  <th scope="col"><FormattedMessage {...messages.status} /></th>
                  <th scope="col"><FormattedMessage {...messages.createdAt} /></th>
                  <th scope="col"><FormattedMessage {...messages.action} /></th>
                  <th scope="col"><FormattedMessage {...messages.deleteAction} /></th>
                </tr>
              </thead>
              <tbody>
                {
                  subCategoryDetails?.getAllSubCategory?.results && subCategoryDetails?.getAllSubCategory?.results?.length > 0 && subCategoryDetails?.getAllSubCategory?.results?.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td data-label={formatMessage(messages.id)}>{item.id}</td>
                        <td data-label={formatMessage(messages.subCategoryName)}>{item.name}</td>
                        <td data-label={formatMessage(messages.categoryName)}>{item.categoryName}</td>
                        <td data-label={formatMessage(messages.status)}>
                          <div>
                            <select value={item.status} onChange={(e) => { this.handleStatus(item.id, currentPage, 'status', e) }} className={bt.selectInput}>
                              <option value="active">{formatMessage(messages.active)}</option>
                              <option value="inactive">{formatMessage(messages.inactive)}</option>
                            </select>
                          </div>
                        </td>
                        <td data-label={formatMessage(messages.createdAt)}>{moment(parseInt(item.createdAt)).format('DD-MM-YYYY')}</td>
                        <td data-label={formatMessage(messages.action)}>
                          <div>
                            <Link to={'/siteadmin/sub-category/edit/' + item.id} className={s.noLink}>
                              <CommonAdminEditIcon className={cx(s.editIcon, 'editIconRTL')} />
                              <span className={s.vtrMiddle}>
                                <FormattedMessage {...messages.editAction} />
                              </span>
                            </Link>
                          </div>
                        </td>
                        <td data-label={formatMessage(messages.deleteAction)}>
                          <div>
                            <Button onClick={() => this.handleDelete(item.id, currentPage)} className={s.iconBtn}>
                              <CommonAdminTrashIcon className={cx(s.editIcon, 'editIconRTL')} />
                              <span className={s.vtrMiddle}>
                                <FormattedMessage {...messages.deleteAction} />
                              </span>
                            </Button>
                          </div>
                        </td>
                      </tr>
                    )
                  })
                }
                {
                  !loading && subCategoryDetails?.getAllSubCategory?.results && subCategoryDetails?.getAllSubCategory?.results?.length == 0 && (
                    <tr>
                      <td colspan="12" className={'tableNoRecordCel'}><FormattedMessage {...messages.noResult} /></td>
                    </tr>
                  )
                }
              </tbody>
            </Table>
          </div>}
        {
          subCategoryDetails?.getAllSubCategory?.results && subCategoryDetails?.getAllSubCategory?.results?.length > 0
          && <div className={cx(bt.space5, bt.spaceTop5)}>
            <CustomPagination
              total={subCategoryDetails?.getAllSubCategory?.count}
              currentPage={currentPage}
              defaultCurrent={1}
              defaultPageSize={10}
              change={this.paginationData}
              paginationLabel={formatMessage(messages.subCategories)}
            />
          </div>
        }
      </div>
    );
  }
}

const mapDispatch = {
  updateSubCategoryStatus,
  deleteSubCategory,
  demoRestriction
};
const mapState = (state) => ({});

export default injectIntl(compose(
  withStyles(bt, s),
  connect(mapState, mapDispatch)
)(SubCategoryList))
